import React from 'react'
import Loadable from 'react-loadable'
import ChunkErrorBoundary from './ChunkErrorBoundary'

// Every lazy route goes through here, so this is the one place a chunk failure can be
// caught for all of them. See ChunkErrorBoundary for why a blank page was the old outcome.
export default (loader, extraProps) => {
  const options = {
    loader,
    delay: false,
    loading: () => <div />,
  }

  if (extraProps) {
    options.render = (loaded, props) => {
      let Component = loaded.default
      return <Component {...props} {...extraProps} />
    }
  }
  const LoadableComponent = Loadable(options)

  // Wrapped rather than boundaried inside `loading`: react-loadable renders `loading`
  // while the import is still in flight, so a boundary in there is not mounted at the
  // moment the loader rejects. It has to sit ABOVE the Loadable component.
  //
  // Safe for every caller: this factory is only ever invoked at module scope inside the
  // route config objects, so `Wrapped` has a stable identity and cannot remount a route on
  // re-render, and routes consume it as `<Route component={...} />`, which takes any
  // component type.
  const Wrapped = props => (
    <ChunkErrorBoundary>
      <LoadableComponent {...props} />
    </ChunkErrorBoundary>
  )
  // Nothing in this codebase calls .preload() today (checked), but forwarding it keeps the
  // returned value API-compatible with what react-loadable handed back before the wrap, so
  // adding route-level preloading later does not have to come back through here.
  Wrapped.preload = LoadableComponent.preload
  return Wrapped
}
